"use strict";

define('rs/authenticate/authenticate.controller',['vertebrae', 'rs/authenticate/authenticate.view', 'rs/models/session', 'rs/models/user', 'rs/helper', 'cookie', 'evisions/validation', 'rs/errors'], function (Vertebrae, AuthenticateView, Session, User, helper, cookie, validation, RSErrors) {
  var AuthenticateController = Vertebrae.Controller.extend({
    properties: ['User', 'Mode', 'LogoutReason', 'presetUsers'],
    validators: {
      'username': [validation.empty()],
      'password': [validation.empty()],
      'forgotEmailInput': [validation.email(), validation.empty()],
      'forgotUserInput': [validation.empty()]
    },
    events: {
      'view:ready': null
    },
    presetUsers: [{
      username: 'cayuseadmin',
      password: 'a'
    }],
    mode: null,
    initialize: function initialize() {
      var users = ['a', 'analyst_1', 'reviewer_1', 'researcher_1', 'org_approver_1'];
      this._super.apply(this, arguments);
      for (var i = 0, len = users.length; i < len; i++) {
        this.presetUsers.push({
          username: users[i],
          password: 'a'
        });
      }
    },
    setupView: function setupView() {
      this.setView(new AuthenticateView());
    },
    setupUser: function setupUser() {
      this.setLogoutReason($.cookie('RS.LogoutReason'));
      $.removeCookie('RS.LogoutReason', {
        path: '/'
      });
      return User.setup();
    },
    requestLogin: function requestLogin() {
      var view = this.getView(),
        origUsername = view.getUsername(),
        origTenantPath = view.getTenant(),
        username = origUsername,
        password = view.getPassword(),
        presetUser = this.getPresetUsers()[view.getPresetUser()],
        tenantPath = '||' + view.getTenant(),
        usernameHasTenant = username.indexOf('||') > -1;
      username = usernameHasTenant ? username : username + tenantPath;
      if (presetUser) {
        origUsername = presetUser.username;
        username = presetUser.username + tenantPath;
        password = presetUser.password;
      }
      if (!this.currentlyLoggingIn) {
        if (presetUser || this.validate(['username', 'password'])) {
          this.currentlyLoggingIn = true;
          return User.requestLogin(username, password).bind(this).lastly(view.showLoading()).lastly(function () {
            this.currentlyLoggingIn = false;
          }).tap(function () {
            this.saveLogin(origUsername, origTenantPath);
          }).tap(this.userIsAuthenticated).caught(RSErrors.APIError, function (e) {
            this.userAuthenticationDidFail(e);
          });
        }
      }
    },
    requestForgotUsername: function requestForgotUsername(email) {
      if (this.validate(['forgotEmailInput'])) {
        User.doesEmailExist(email).bind(this).then(function () {
          this.getView().popoverConfirmation();
        }).caught(function (e) {
          this.getView().popoverError();
          throw e;
        });
      }
    },
    requestForgotPassword: function requestForgotPassword(email, username) {
      if (this.validate(['forgotEmailInput', 'forgotUserInput'])) {
        User.doesUserWithEmailExist(email, username).bind(this).then(function () {
          this.getView().popoverConfirmation();
        }).fail(function () {
          this.getView().popoverError();
        });
      }
    },
    userAuthenticationDidFail: function userAuthenticationDidFail(err) {
      var msg = err.serverResponse ? err.serverResponse : err;
      this.getView().showLoginError(this.createErrorMsg(msg));
    },
    createErrorMsg: function createErrorMsg(err) {
      var defaultErrorMsg = 'Oops....something unexpected went wrong.',
        errorMsg = err && err.error || defaultErrorMsg;
      if (errorMsg && !_.isString(errorMsg)) {
        if (errorMsg.promise) {
          errorMsg = defaultErrorMsg;
        } else {
          errorMsg = '[' + errorMsg.id + '] ' + errorMsg.message;
        }
      }
      return errorMsg;
    },
    viewIsReady: function viewIsReady() {
      var mode = this.getMode();
      if (!mode) {
        this.setupUser().bind(this).tap(this.userIsAuthenticated).caught(RSErrors.NoSessionError, function (e) {
          this.userNotAuthenticated();
          throw e;
        });
      } else if (mode == "forgotPasswordVerify") {
        this.getView().render(mode);
        this.verifyPasswordChange();
      }
    },
    verifyPasswordChange: function verifyPasswordChange() {
      var hashArgs = this.getForgotArguments(),
        that = this;
      User.verifyPasswordReset(hashArgs.userId, hashArgs.hash).then(function () {
        that.getView().showForgotFields();
      }).fail(function () {
        that.getView().showForgotMessage("Your password reset request has expired.");
      });
    },
    getForgotArguments: function getForgotArguments() {
      var split = window.location.hash.split('/');
      return {
        userId: split[1],
        hash: split[2]
      };
    },
    userIsAuthenticated: function userIsAuthenticated(user, loginStr) {
      this.trigger('authenticated', user);
    },
    saveLogin: function saveLogin(login, tenant) {
      $.cookie('RS.Tenant', tenant, {
        expires: 365,
        path: '/'
      });
      if (this.getView().getRememberMe()) {
        $.cookie('RS.Username', login, {
          expires: 365,
          path: '/'
        });
      } else if (this._mustLogIn) {
        $.removeCookie('RS.Username', {
          path: '/'
        });
      }
    },
    requestPasswordReset: function requestPasswordReset(password, repassword) {
      if (password == repassword) {
        var args = this.getForgotArguments();
        User.resetPassword(args.userId, args.hash, password).bind(this).then(function () {
          this.getView().showForgotMessage("Password successfully changed.");
          setTimeout(function () {
            window.location.href = window.location.origin;
          }, 2500);
        }).fail(function () {
          this.getView().showForgotMessage("An error occured while changing your password.<br>Please try again later.");
        });
      } else {
        this.getView().showPasswordResetError();
      }
    },
    userNotAuthenticated: function userNotAuthenticated() {
      this._mustLogIn = true;
      this.getView().render();
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        username: $.cookie('RS.Username'),
        logoutReason: this.getLogoutReason(),
        presetUsers: this.presetUsers,
        tenant: $.cookie('RS.Tenant') || 'dummy.host'
      };
    }
  });
  return AuthenticateController;
});

